
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 4 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1.9","cy":"1.9","r":"1.9","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.9","cy":"10.7","r":"1.9","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.9","cy":"19.5","r":"1.9","fill":"currentColor"}})])
          )
        }
      }
    